// This hook checks if Onboarding or Email Opt In or Bonus Rolling modal is already present on the page load

import { useEffect, useState } from 'react';
import { useTimeoutIsOver } from 'core/hooks/useTimeoutIsOver';
import { useModal } from 'core/modules/Modal/ModalProvider';

const canJsSelectors = ['.mn_emailOptInOverlayWrap', '.mn_emailOptInOverlay.mn_emailSuccess'];
const modalIds = ['mt_bonusRolling', 'mt_emailOptInSuccess', 'mt_emailOptInSubscribe'];

export const useModalDetection = () => {
  const { modal = {} } = useModal();
  const isTimeoutOver = useTimeoutIsOver(2500);
  const [hasOpenModal, setHasOpenModal] = useState(null);

  useEffect(() => {
    // Add some delay in case other modals are not rendered immediately on the page load
    if (isTimeoutOver) {
      const hasOnboarding = !!document.documentElement.dataset.showOnboarding;
      const hasExcludedModal = modalIds.includes(modal.name);
      const hasCanJsExcludedModal = !!document.querySelector(canJsSelectors.join(', '));
      setHasOpenModal(hasOnboarding || hasExcludedModal || hasCanJsExcludedModal);
    }
  }, [isTimeoutOver]);

  return hasOpenModal;
};
